module.exports = __webpack_public_path__ + "static/img/bg_7.2153fc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_7.jpg
// module id = o45O
// module chunks = 1